module.exports = __webpack_public_path__ + "img/arrow-right-white.c6d362d8.svg";